const state = {
  type: null,
  message: null
}

const getters = {
  getAlert (state) {
    return state
  }
}

const mutations = {
  success (state, message) {
    state.type = 'success'
    state.message = message
  },
  error (state, message) {
    state.type = 'error'
    state.message = message
  },
  clear (state) {
    state.type = null
    state.message = null
  }
}

const actions = {
  success (context, message) {
    context.commit('success', message)
  },
  error (context, message) {
    context.commit('error', message)
  },
  clear (context) {
    context.commit('clear')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
